// extracted by mini-css-extract-plugin
export var actionButton = "_nc-0";
export var actionMenuContainer = "_nc-i";
export var bubble = "_nc-2";
export var bubbleActionMenu = "_nc-j";
export var bubbleContext = "_nc-6";
export var bubbleItems = "_nc-7";
export var customer = "_nc-3";
export var divider = "_nc-8";
export var fileList = "_nc-9";
export var hiddenComment = "_nc-o";
export var infoAbove = "_nc-a";
export var internal = "_nc-4";
export var lightActionButton = "_nc-1";
export var link = "_nc-b";
export var merchant = "_nc-5";
export var message = "_nc-c";
export var profilePicture = "_nc-e";
export var quillToolbarContainer = "_nc-f";
export var senderDate = "_nc-g";
export var senderDateCustomer = "_nc-h";
export var senderName = "_nc-d";
export var time = "_nc-k";
export var uploadedImage = "_nc-l";
export var username = "_nc-m";
export var xsmall = "_nc-n";